import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface ILiveCasinoIconProps extends ISvgIconProps {

}

export class LiveCasinoIcon extends React.Component<ILiveCasinoIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M15.642 11.852 9 15.484V8.22z" strokeLinecap="round" strokeLinejoin="round"/>
                    <g transform="translate(2.5 4)">
                        <rect width="19" height="16" rx="2" stroke="none"/>
                        <rect x=".75" y=".75" width="17.5" height="14.5" rx="1.25"/>
                    </g>
                </g>
            </SvgIcon>
        );
    }
}
